/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Plausible_DomainInputs */

const en_admin_settings_fields_plausible_domain = /** @type {(inputs: Admin_Settings_Fields_Plausible_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain`)
};

/**
* | output |
* | --- |
* | "Domain" |
*
* @param {Admin_Settings_Fields_Plausible_DomainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_plausible_domain = /** @type {((inputs?: Admin_Settings_Fields_Plausible_DomainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Plausible_DomainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_plausible_domain(inputs)
});
export { admin_settings_fields_plausible_domain as "admin.settings.fields.plausible_domain" }